import { SeuConfigInputItem } from '@seu-types';

export type SeuGlobalValuesPresetInputs = {
  presetId: string | null;
  inputs: SeuConfigInputItem[];
};

export const SEU_GLOBAL_VALUES_OPEX_CONFIG_KEY = 'operationalExpenditures';
